import { formatDate } from "../services/receipt.service";
import {
    COLORS, buildDocDefinition, openPdf, headerRowOf, zebraRow, totalRow, emptyRow,
    fmtLongDate, fmtAmount, fmtINR, sumBy,
} from "./reportTheme";

// SN | Receipt No | Receipt Date | Devotee | Mobile | Seva Date | Persons | Amount
const WIDTHS = [22, 50, 56, "*", 62, 56, 40, 58];
const COLS = WIDTHS.length;

export const SevaWiseReportPrint = async (poojaName, fromDate, toDate, logoBase64, sevaWiseReportList = []) => {
    const grandTotal = sumBy(sevaWiseReportList, "totalAmount");
    const totalPersons = sumBy(sevaWiseReportList, "totalPerson");

    const body = [
        headerRowOf([
            ["SN", "center"], ["Receipt No"], ["Receipt Date"], ["Devotee"], ["Mobile"],
            ["Seva Date"], ["Persons", "right"], ["Amount (₹)", "right"],
        ]),
        ...sevaWiseReportList.map((item, i) =>
            zebraRow([
                { text: i + 1, alignment: "center", color: COLORS.muted },
                { text: item.receiptNo || "-", bold: true },
                { text: formatDate(item.receiptDate) || "-" },
                { text: item.devoteeName || "-" },
                { text: item.mobile || "-" },
                { text: formatDate(item.poojaDateTime1) || "-" },
                { text: item.totalPerson || "-", alignment: "right" },
                { text: fmtAmount(item.totalAmount), alignment: "right" },
            ], i)
        ),
        sevaWiseReportList.length
            ? totalRow("Grand Total", fmtINR(grandTotal), { grand: true, cols: COLS, extra: totalPersons })
            : emptyRow("No records found", COLS),
    ];

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: `${poojaName || "Seva"} Collection List`,
            summary: [
                { label: "Period", value: `${fmtLongDate(fromDate)} – ${fmtLongDate(toDate)}` },
                { label: "Total Receipts", value: sevaWiseReportList.length },
                { label: "Total Collection", value: fmtINR(grandTotal), accent: true },
            ],
            body,
            widths: WIDTHS,
        })
    );
};

export default SevaWiseReportPrint;